// @ts-nocheck
import {useListView} from '../../core/ListViewProvider'
import {UsersListToolbar} from './UserListToolbar'
import {UsersListGrouping} from './UsersListGrouping'
import {UsersListSearchComponent} from './UsersListSearchComponent'

type SearchProps = {
  userSearch: String
  setUserSearch: Function
}

const UsersListHeader = ({
  userSearch,
  setUserSearch,
  setSDate,
  setEDate,
  sDate,
  eDate,
  page,
  setPage,
}: SearchProps) => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <UsersListSearchComponent userSearch={userSearch} setUserSearch={setUserSearch} />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? (
          <UsersListGrouping />
        ) : (
          <UsersListToolbar
            sDate={sDate}
            setSDate={setSDate}
            eDate={eDate}
            setEDate={setEDate}
            page={page}
            setPage={setPage}
          />
        )}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {UsersListHeader}
